export type PrivateLessonPackageKind =
  | "individual"
  | "group"
  | "private_shared";

export function isMultiMemberPackageKind(
  kind: PrivateLessonPackageKind | string | null | undefined,
): boolean {
  return kind === "group" || kind === "private_shared";
}

export function multiMemberPackageLabel(
  kind: PrivateLessonPackageKind | string | null | undefined,
): string | null {
  if (kind === "group") return "ກຸ່ມ";
  if (kind === "private_shared") return "Private Package";
  return null;
}

export function multiMemberBookingTitle(
  kind: PrivateLessonPackageKind | string | null | undefined,
): string {
  if (kind === "group") return "ຮຽນກຸ່ມ";
  if (kind === "private_shared") return "Private Package";
  return "ຮຽນສ່ວນຕົວ";
}
